import type * as React from "react";

import { Button } from "@/web/components/primitives/button";
import { DrawerBody, DrawerFooter } from "@/web/components/primitives/drawer";
import { cn } from "@/web/lib/styling";

export function ReviewStepFrame({
  children,
  footer,
}: {
  children: React.ReactNode;
  footer: React.ReactNode;
}) {
  return (
    <>
      <div className="relative min-h-0 flex-1">
        <DrawerBody className="h-full px-6 pb-8">
          <div className="flex min-h-full flex-col">{children}</div>
        </DrawerBody>
        <div
          aria-hidden
          className="pointer-events-none absolute inset-x-0 bottom-0 h-16 bg-linear-to-b from-withus-white/0 to-withus-white"
        />
      </div>
      <DrawerFooter className="shrink-0 bg-withus-white pt-0">{footer}</DrawerFooter>
    </>
  );
}

export function ReviewStepHeading({
  title,
  description,
  mutedDescription,
}: {
  title: string;
  description: React.ReactNode;
  mutedDescription?: boolean;
}) {
  return (
    <div className="flex flex-col gap-4 pt-2 pb-6">
      <h2 className="font-heading text-2xl leading-none text-withus-dark-blue uppercase">
        {title}
      </h2>
      <p
        className={cn(
          "max-w-82 text-base leading-snug",
          mutedDescription ? "text-withus-dark-blue/60" : "text-withus-dark-blue",
        )}
      >
        {description}
      </p>
    </div>
  );
}

export function ReviewActionButton({
  onClick,
  label,
  meta,
  icon,
  disabled,
}: {
  onClick: () => void;
  label: string;
  meta?: string;
  icon?: React.ReactNode;
  disabled?: boolean;
}) {
  return (
    <Button color="red" size="lg" className="w-full" disabled={disabled} onClick={onClick}>
      <span>{label}</span>
      {meta ? <span className="opacity-60">{meta}</span> : null}
      {icon}
    </Button>
  );
}
